import React from 'react';
import "../components.css";


export default function Tile({style}: {style: any}) {
    return (
        <div className="tile" style={style}>
            <h1>Tile</h1>
        </div>
    )
}